import { BASE_URL_DYNAMIC } from "../services/api/base-query";

/**
 * Resolves a file URL coming from the API (typically /api/files/{guid})
 * into an absolute URL pointing at the configured backend host.
 *
 * - http/https/blob/data URLs pass through unchanged.
 * - Empty/null/undefined returns undefined so callers can fall back to a
 *   placeholder with `?? avatarPlaceholder`.
 * - Anything else (bundler-resolved `../images/x.png`, etc.) is returned
 *   as-is so existing code keeps working.
 */
export const resolveFileUrl = (url?: string | null): string | undefined => {
  if (!url) return undefined;
  if (/^(https?:|blob:|data:)/i.test(url)) return url;
  if (url.startsWith("/api/files/")) {
    const base = (BASE_URL_DYNAMIC || "").replace(/\/+$/, "");
    return `${base}${url}`;
  }
  return url;
};

/**
 * True iff the resolved URL points at this app's API host under /api/files/.
 * Used to decide whether to attach `crossOrigin="use-credentials"` so the
 * bpreven.auth HttpOnly cookie rides along on cross-origin media requests.
 */
export const isApiFileUrl = (resolvedUrl?: string): boolean => {
  if (!resolvedUrl || !BASE_URL_DYNAMIC) return false;
  const base = BASE_URL_DYNAMIC.replace(/\/+$/, "");
  return resolvedUrl.startsWith(`${base}/api/files/`);
};
